export default __webpack_public_path__ + "static/media/new_cnaps_logo.67e4100d.svg";